export default "__VITE_ASSET__a32174df__"